import request from "../util/request";

/**
 * 角色列表
 * @param model
 * @returns {AxiosPromise}
 */
export function rolePage(model) {
    return request({
        url: '/api-admin/role/page',
        method: 'post',
        data: model
    })
}

/**
 * 用户绑定角色
 * @param model
 * @returns {AxiosPromise}
 */
export function userBindRole(model) {
    return request({
        url: '/api-admin/permission/user/bind/role',
        method: 'post',
        data: model
    })
}
